import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { Box, FormControl, InputLabel, MenuItem, Select, Tooltip } from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
import Parser from 'html-react-parser';
import { storeContext } from "../../provider/Provider";
import { digitalPRActions } from "../../../store/digital-pr-reducer";
// import { getCampaignLinks } from "../services/index.service";
import { convertToTitleCase } from "../../../functions";
import theme from "../../../theme";
import CONSTANTS from "../../../utils/constants";
import { StyledActiveChip, StyledInactiveChip, StyledLightActiveChip, useStyles } from "../styles/index.style";
import ChipBadge from "../../../customUI/ChipBadge";

export const useDigitalPR = () => {
   const classes = useStyles();
   const { state, dispatch } = useContext(storeContext);
   const rowPerPage = 10;
   const [snackbarOpen, setSnackbarOpen] = useState(false);
   const stateRef = useRef(state.digitalPR.currentTable);

   useEffect(() => {
      stateRef.current = state.digitalPR.currentTable;
   }, [state.digitalPR.currentTable]);

   const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

   const handleCampaignPageChange = (event, newPage) => {
      dispatch({
         type: digitalPRActions.SET_CAMPAIGN_FILTER,
         payload: { 
            campaignFilters: {
               page: newPage
            }
         },
       });
   }

   const handleCampaignPerPageChange = (event) => {
      dispatch({
         type: digitalPRActions.SET_CAMPAIGN_FILTER,
         payload: { 
            campaignFilters: {
               perPage: event.target.value
            }
         },
       });
   }

   const handleShowDropdown = (rowIndex) => state.digitalPR.campaignList[rowIndex].campaigns_count > 1;

   // const handleExpandClicked = async(rowIndex) => {
   //    const campaignID = state.digitalPR.campaignList[rowIndex].id
   //    const isExpanded = state.digitalPR.campaignList[rowIndex].children?.expanded

   //    if(!isExpanded){
   //       dispatch({
   //          type: digitalPRActions.SET_CAMPAIGNS_LOADING,
   //          payload: { 
   //             loading: true,
   //             campaignID
   //          }
   //       });
         
   //       getCampaignLinks(campaignID)
   //       .then((res) => {
   //          if (!res.data) {
   //             return;
   //          }
   
   //          dispatch({
   //             type: digitalPRActions.SET_CAMPAIGNS_CHILD,
   //             payload: {
   //                childCampaignList: res.data.results,
   //                campaignID,
   //             }
   //          });
   //       }).finally(() => {
   //          dispatch({
   //             type: digitalPRActions.SET_CAMPAIGNS_LOADING,
   //             payload: { 
   //                loading: false,
   //                campaignID
   //             }
   //          });
   //       })
   //    }
   //    dispatch({
   //       type: digitalPRActions.SET_CAMPAIGNS_EXPAND,
   //       payload: { 
   //          campaignID
   //       }
   //    });
   // }

   const handleExpandClicked = async(rowIndex) => {
      const {month} = state.digitalPR.campaignList[rowIndex]
      const isExpanded = state.digitalPR.campaignList[rowIndex].children?.expanded

      if(!isExpanded){
   
         dispatch({
            type: digitalPRActions.SET_CAMPAIGNS_CHILD,
            payload: {
               childCampaignList: state.digitalPR.campaignList[rowIndex].campaigns,
               month,
            }
         });
         
      }
      dispatch({
         type: digitalPRActions.SET_CAMPAIGNS_EXPAND,
         payload: { 
            month
         }
      });
   }

   const handleFilterChange = (value) => {
      dispatch({
          type: digitalPRActions.SET_SELECTED_CAMPAIGN_TYPE,
          payload: { 
             selectedCampaignType: value,
          }
      });
  }

   const handleActiveSortClick = (value) => {
      if (state.digitalPR.activeOrderBy === `${value}`){
         dispatch({
            type: digitalPRActions.SET_ACTIVE_ORDER_BY,
            payload: { 
               activeOrderBy: `-${value}`
            }
         });
        return;
      }
      
      dispatch({
         type: digitalPRActions.SET_ACTIVE_ORDER_BY,
         payload: { 
            activeOrderBy: `${value}`
         }
      });
    };

   const columns = [
      {
         header: "Date",
         key: "month",
         sort: {
            sortable: true,
            selected: state.digitalPR.activeOrderBy,
            onClick: handleActiveSortClick,
         },
         cell: (row) => (<Box>{row.month? moment(row.month).format('MMM YYYY'): '-'}</Box>),
         cellStyle: { fontSize: "1rem" },
      },
      {
         header: "Topic",
         key: "campaigns",
         cell: (row) => (<Box>{row.campaigns_count > 1 ? "Multiple Topics" : row.campaigns[0].topic}</Box>),
         cellStyle: { fontSize: "1rem" },
      },
      {
         header: (<FormControl variant="outlined" style={{ minWidth: 70 }}>
              <InputLabel>Type</InputLabel>
              <Select
              value={state.digitalPR.selectedCampaignType}
              onChange={(event) => {
                  handleFilterChange(event.target.value)
              }}
              label="Type"
              aria-label="select type"
              >
              {CONSTANTS.availableCampaignTypes.map((type) => (
                  <MenuItem value={type.value} key={type.value}>
                  {type.label}
                  </MenuItem>
              ))}
              </Select>
          </FormControl>),
         key: "type",
         cell: (row) => {
            if (row.campaigns_count > 1) {
               return (<Box>-</Box>);
            }
            const campaignType = CONSTANTS.availableCampaignTypes.slice(1).find(
               (type) => type.value === row.campaigns[0]?.type
            );
            return (<Box>{campaignType?.label || '-'}</Box>);
         }
      },
      {
         header: "Page Copy",
         key: "campaigns",
         cell: (row) => {
            if(row.campaigns_count>1){
               return (
                  <p style={{
                     cursor: 'not-allowed',
                     color: 'grey',
                     padding: "0 5px",
                  }}>n/a</p>
               )
            }
            if(row.campaigns[0].page_copy){
               return (
               <a
               href={row.campaigns[0].page_copy}
               style={{ cursor: 'pointer', color: '#2A5CA9' }}
               target="_blank"
               rel="noreferrer"
               >
               Open Content Page &gt;&gt;
               </a>
            )}
            return (
            <p
              style={{
                cursor: 'not-allowed',
                color: 'grey',
                padding: "0 5px",
              }}
            >
              n/a
            </p>
          )},
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Status",
         key: "campaigns",
         cellStyle: { fontSize: "1rem" },
         cell: (row) => {
            if(row.campaigns_count>1) {
               const hasInProgress = row.campaigns.some(campaign => 
                  campaign?.platform_status?.toLowerCase() !== 'complete'
               );
               return hasInProgress ? 'Pitching' : 'Complete';
            }
            return convertToTitleCase(row.campaigns[0].platform_status);
         },
      },
      {
         header: "Notes",
         key: "campaigns",
         cell: (row) => (<Box ml='5px' mt='5px'>
            {row.campaigns_count>1?
            <Box>-</Box>:
            <Tooltip title={row.campaigns[0].client_notes && Parser(row.campaigns[0].client_notes || '')? Parser(row.campaigns[0].client_notes || ''): "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
               <InfoIcon 
                  onClick={() => { 
                     dispatch({
                        type: digitalPRActions.SET_CLIENT_NOTES_OPEN,
                        payload: { 
                           clientNotesOpen: true,
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_CLIENT_NOTE,
                        payload: { 
                           selectedClientNote: row.campaigns[0].client_notes || "No notes available!",
                        }
                     })
                  }} 
                  style={{color: theme.palette.primary.main, cursor: 'pointer'}} />
            </Tooltip>}
         </Box>),
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Links",
         key: "links_count",
         sort: {
            sortable: true,
            selected: state.digitalPR.activeOrderBy,
            onClick: handleActiveSortClick,
         },
         cell: (row) => {
            if(row.total_links > 0 && row.campaigns_count === 1){
               return (<Box 
                  style={{color: '#699ad6', textDecoration: 'underline', cursor: 'pointer'}} 
                  onClick={() => {
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_CAMPAIGN,
                        payload: { 
                           selectedCampaign: row.campaigns[0], 
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
                        payload: { 
                           linksDialogOpen: true, 
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_LINK_TYPE,
                        payload: { 
                           selectedLinkType: "all", 
                        }
                     })
                  }}>{row.total_links}</Box>)
            }
            if(row.total_links > 0) {
               return (<Box>{row.total_links}</Box>)
            }
            return (<Box>0</Box>)
            },
         cellStyle: { fontSize: "1rem" },
      },
      {
         header: "DR 70+",
         key: "links_above_70_dr",
         sort: {
            sortable: true,
            selected: state.digitalPR.activeOrderBy,
            onClick: handleActiveSortClick,
         },
         cell: (row) => {
            if(row.dr_70_links > 0 && row.campaigns_count === 1){
               return (<Box 
                  style={{color: '#699ad6', textDecoration: 'underline', cursor: 'pointer'}} 
                  onClick={() => {
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_CAMPAIGN,
                        payload: { 
                           selectedCampaign: row.campaigns[0], 
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
                        payload: { 
                           linksDialogOpen: true, 
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_LINK_TYPE,
                        payload: { 
                           selectedLinkType: "+70", 
                        }
                     })
                  }}>{row.dr_70_links}</Box>)
            }
            if(row.dr_70_links > 0) {
               return (<Box>{row.dr_70_links}</Box>)
            }
            return (<Box>0</Box>)
            },
         cellStyle: { fontSize: "1rem" },
      },
      {
         header: "Target",
         key: "target_status_platform",
         showDropdown: handleShowDropdown,
         onExpand: handleExpandClicked,
         cell: (row) => (<ChipBadge
            anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }}
            color="secondary"
         >
            {row.target_status_platform === "exceeds" &&
               (<StyledActiveChip
                  label="Exceeds"
                  className={classes.chipMargin}
                  />)}
            {row.target_status_platform === "meets" &&
               (<StyledLightActiveChip
                  label="Meets"
                  className={classes.chipMargin}
                  />)}
            {row.target_status_platform === "in_progress" &&
               (<StyledInactiveChip
                  label="In Progress"
                  className={classes.chipMargin}
                  />)}
         </ChipBadge>),
         cellStyle: { fontSize: "1rem", width: "100px", maxWidth: "100px", padding: "0 8px" },
      },
   ]

   const childColumns = [
      {
         header: "",
         key: "date",
         cell: (row) => (<Box>{row.date? moment(row.date).format('MMM YYYY'): '-'}</Box>),
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Angle",
         key: "topic",
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Type",
         key: "type",
         cell: (row) => (<Box>{CONSTANTS.availableCampaignTypes.slice(1).find(
            (campaignType) => campaignType.value === row.type
          )?.label || '-'}</Box>),
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Additional Content",
         key: "page_copy",
         cell: (row) => {
            if( row.page_copy){
               return (
               <a
               href={row.page_copy}
               style={{ cursor: 'pointer', color: '#2A5CA9' }}
               target="_blank"
               rel="noreferrer"
               >
               Open Content Page &gt;&gt;
               </a>
            )}
            return (
            <p
              style={{
                cursor: 'not-allowed',
                color: 'grey',
                padding: "0 5px",
              }}
            >
              n/a
            </p>
          )},
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "Status",
         key: "platform_status",
         cellStyle: { fontSize: "1rem" },
         cell: (row) => (convertToTitleCase(row.platform_status)),
      },
      
      {
         header: "Notes",
         key: "client_notes",
         cell: (row) => (<Box ml='5px' mt='5px'>
            <Tooltip title={row.client_notes && Parser(row.client_notes || '')? Parser(row.client_notes || ''): "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
               <InfoIcon 
                  onClick={() => { 
                     dispatch({
                        type: digitalPRActions.SET_CLIENT_NOTES_OPEN,
                        payload: { 
                           clientNotesOpen: true,
                        }
                     })
                     dispatch({
                        type: digitalPRActions.SET_SELECTED_CLIENT_NOTE,
                        payload: { 
                           selectedClientNote: row.client_notes || "No notes available!",
                        }
                     })
                  }} 
                  style={{color: theme.palette.primary.main, cursor: 'pointer'}} />
            </Tooltip>
         </Box>),
         cellStyle: { fontSize: "1rem" }
      },
      
      {
         header: "Links",
         key: "total_links",
         cell: (row) => (row.total_links>0? 
            <Box 
               style={{color: '#699ad6', textDecoration: 'underline', cursor: 'pointer'}} 
               onClick={() => {
                  dispatch({
                     type: digitalPRActions.SET_SELECTED_CAMPAIGN,
                     payload: { 
                        selectedCampaign: row, 
                     }
                  })
                  dispatch({
                     type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
                     payload: { 
                        linksDialogOpen: true, 
                     }
                  })
                  dispatch({
                     type: digitalPRActions.SET_SELECTED_LINK_TYPE,
                     payload: { 
                        selectedLinkType: "all", 
                     }
                  })
               }}>
               {row.total_links}</Box>:
            <Box>0</Box>),
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "DR 70+",
         key: "dr_70_links",
         cell: (row) => (row.dr_70_links>0? 
            <Box 
               style={{color: '#699ad6', textDecoration: 'underline', cursor: 'pointer'}} 
               onClick={() => {
                  dispatch({
                     type: digitalPRActions.SET_SELECTED_CAMPAIGN,
                     payload: { 
                        selectedCampaign: row,
                     }
                  })
                  dispatch({
                     type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
                     payload: { 
                        linksDialogOpen: true, 
                     }
                  })
                  dispatch({
                     type: digitalPRActions.SET_SELECTED_LINK_TYPE,
                     payload: { 
                        selectedLinkType: "+70", 
                     }
                  })
               }}>
               {row.dr_70_links}</Box>:
            <Box>0</Box>),
         cellStyle: { fontSize: "1rem" }
      },
      {
         header: "",
         key: "links_count",
         cell: () => (<Box>-</Box>),
         cellStyle: { fontSize: "1rem" }
      },
   ]

   const style = {
      tableHead: {
         backgroundColor: "#F2F5F7", 
      },
      headCell: {
         color: "#101010",
         fontSize: "1rem",
      }
   }

   const childStyle = {
      tableHead: {
         backgroundColor: "#F2F5F7", 
         padding: "0px !important",
         border: "1px solid #E8E8E0"
      },
      headCell: {
         color: "#58595B",
         fontWeight: 700,
      }
   }

   const getRowStyle = (row) => ({
      backgroundColor: row.campaigns_count > 1 ? '#f9fcff' : 'inherit'
   });

   const onCampaignFiltersChange = (newObject) => {
      if(stateRef.current === CONSTANTS.ActiveCampaigns){
         dispatch({
            type: digitalPRActions.SET_CAMPAIGN_FILTER,
            payload: { 
               campaignFilters: newObject
            },
         });
      }
   }

   const linkBarColor = useMemo(() => ['#00B5E2', '#013220', '#808080'], []);

   const barOptions = {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
         show: false,
        },
        events: {
         dataPointSelection: (event, chartContext, config) => {
            const startDate = `${config.w.config.xaxis.categories[config.dataPointIndex]}-01`
            const endDate = moment(`${config.w.config.xaxis.categories[config.dataPointIndex]}-01`).endOf('month').format('YYYY-MM-DD')
            onCampaignFiltersChange({fromDate: moment(startDate).format('YYYY-MM-DD'), toDate: endDate})   
            
            setSnackbarOpen(true);
          }
         }
      },
      xaxis: {
         categories: Object.keys(state.digitalPR.linksByMonth).map((key) => moment(key).format("MMM-YYYY")),
       },
      fill: {
         colors: linkBarColor,
      },
      dataLabels: {
         enabled: false,
       },
      plotOptions: {
        bar: {
          vertical: true
        }
      },
    }

    function convertMonthYear(input) {
      const parts = input.split('-');
      if (parts.length !== 2) {
        return "Invalid input format. Please use 'Mon-YYYY' format.";
      }
    
      const monthAbbr = parts[0];
      const year = parts[1];
    
      const monthNames = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
        Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
      };
    
      const month = monthNames[monthAbbr];
    
      if (!month) {
        return "Invalid month abbreviation.";
      }
    
      return `${year}-${month}`;
    }

    const monthBarOptions = {
      ...barOptions,
      fill: {
         colors: ['#0A8C4C', '#E7AB10'],
      },
      tooltip: {
         custom: ({dataPointIndex, w}) => {
           const data = state.digitalPR.linksByMonth[convertMonthYear(w.config.xaxis.categories[dataPointIndex])];
           
           return `<div>
            <div style="padding: 6px; background-color: #eceff1;">${w.config.xaxis.categories[dataPointIndex].split('-').join(' ')}</div>
            <div style="padding: 8px 8px 8px 10px ;">
               <div>Status: ${data.completed? 'Complete': 'In-Progress'}</div>
               <div>Total Links: ${data.count_dr_lt_70 + data.count_dr_ge_70}</div>
               <div>Links > DR70: ${data.count_dr_ge_70}</div>
            </div>
            </div>`;;
         }
      }
    }
   const createLinkSeries = (data, keyPath) => ([
      {
         name: 'Complete',
         data: Object.keys(data).map((key) => {
            if(data[key].completed){
               return data[key][`${keyPath}_dr_lt_70`] + data[key][`${keyPath}_dr_ge_70`]
            }
            return 0
         })
      },
      {
         name: 'In Progress',
         data: Object.keys(data).map((key) => {
            if(data[key].completed){
               return 0
            }
            return data[key][`${keyPath}_dr_lt_70`] + data[key][`${keyPath}_dr_ge_70`]
         })
      },
   ]);

   const createLinkAcquisitionSeries = (data, keyPath) => ([
      {
         name: 'dr < 70',
         data: Object.keys(data).map((key) => data[key][`${keyPath}_dr_lt_70`])
      },
      {
         name: 'dr >= 70', 
         data: Object.keys(data).map((key) => data[key][`${keyPath}_dr_ge_70`])
      }
   ]);

   const linkSeries = useMemo(() => 
      createLinkSeries(state.digitalPR.linksByMonth, 'count'),
      [state.digitalPR.linksByMonth]
   );

   const linkAcquisitionSeries = useMemo(() => 
      createLinkAcquisitionSeries(state.digitalPR.linkAcquisitionsByMonth, 'count'),
      [state.digitalPR.linkAcquisitionsByMonth]
   );

   const distributionSeries = useMemo(() => Object.keys(state.digitalPR.domainRatingDistribution).map((key) => state.digitalPR.domainRatingDistribution[key]), [state.digitalPR.domainRatingDistribution]);

   const distributionOptions = useMemo(() => ({
      chart: {
        width: 200
      },
      legend: {
        position: 'left',
        show: false
      },
      dataLabels: {
         enabled: false,
      },
      plotOptions: {
         pie: {
           donut: {
             size: '45%',
             labels: {
               show: true,
               total: {
                 show: true,
                 label: 'Total Links',
                 fontSize: '10px',
                 fontWeight: 'bold',
                 color: '#898989',
                 formatter(w) {
                   return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                 }
               }
             }
           }
         }
       },
       labels: Object.keys(state.digitalPR.domainRatingDistribution).map((key) => key.split('_').slice(1).join('-')),
       colors: [
         '#666666', 
         '#961A1A', 
         '#B34D86', 
         '#834DB3', 
         '#3486C2', 
         '#65ADD3', 
         '#9DECDF', 
         '#ACE65D', 
         '#6FC74A', 
         '#0A8C4C'
      ]
       ,
    }), [state.digitalPR.domainRatingDistribution]);

   const currentFilters = useMemo(() => state.digitalPR.campaignFilters, [state.digitalPR.campaignFilters])

   const closeVideoPopup = () => {
      dispatch({
         type: digitalPRActions.SET_IS_VIDEO_OPEN,
         payload: {
            isVideoOpen: false
         }
      });
    };

   const filterLabels = {
      'searchTerm': 'Search',
      'fromDate': 'From',
      'toDate': 'To',
   }

   const filteredCampaigns = useMemo(() => {
      if (state.digitalPR.selectedCampaignType === null) {
         return state.digitalPR.campaignList;
      }
      
      return state.digitalPR.campaignList.filter((row) => 
         // Check if any campaign in the campaigns array matches the selected type
         row.campaigns?.some((campaign) => campaign.type === state.digitalPR.selectedCampaignType)
      );
   }, [state.digitalPR.campaignList, state.digitalPR.selectedCampaignType])


   return {
      rowPerPage,
      handleCampaignPageChange,
      handleCampaignPerPageChange,
      columns,
      childColumns,
      style,
      childStyle,
      barOptions,
      monthBarOptions,
      distributionOptions,
      linkSeries,
      linkAcquisitionSeries,
      distributionSeries,
      currentFilters,
      onCampaignFiltersChange,
      closeVideoPopup,
      filterLabels,
      snackbarOpen,
      handleCloseSnackbar,
      filteredCampaigns,
      getRowStyle
   }
}

export default useDigitalPR;